import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RequestPhotoUpdate } from '../models/requestPhotoUpdate';
import { ProfileModel } from '../models/ProfileModel';
import { FileStorageService } from './file-storage.service';
import { switchMap, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfileServicesService {
  apiImg= environment.mongoUrl;
  url=environment.apiUrl;
  apiKey=environment.apiKey;
  constructor(private http:HttpClient, private fileStorage: FileStorageService) {

   }


   saveMongoImage(img:string,fileName:string):Observable<any>{
    return this.fileStorage.uploadBase64Image(img, fileName + '.png', 'portal-perfil').pipe(
      switchMap(fileId => of({ fileId }))
    );
   }

   saveProfileImageUser(img:string,clientNumber:number,userId:number|null):Observable<RequestPhotoUpdate>{
    const request :RequestPhotoUpdate={
      clientNumber: clientNumber,
      userId: userId!,
      image: img,
      isMongo: true
    }

    return this.http.post<RequestPhotoUpdate>(this.url + 'Profile/clientProfileImage', request);
   }

   loadUserImage(clientNumber:number,userId:number):Observable<RequestPhotoUpdate>{
    var params= 'clientNumber='+clientNumber;
    if(userId>0){
      params+='&userId='+userId;
    }
    return this.http.get<RequestPhotoUpdate>(this.url+'Profile/clientProfileImage?'+params);
   }

   loadProfile(clientNumber:number,userId:number):Observable<ProfileModel>{
    var params= 'clientNumber='+clientNumber;
    if(userId>0){
      params+='&userId='+userId;
    }
    return this.http.get<ProfileModel>(this.url+'Profile?'+params);
   }

   loadImageMongo(documentId:string):Observable<any>{
    return this.fileStorage.getDownloadUrl(documentId);
   }
}
